import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  initialize() {
    this.setActiveState = this.setActiveState.bind(this)
  }

  connect() {
    this.activeId = this.element.dataset?.activeId || null

    this.observeList()
    this.addListeners()
    this.restoreActiveState()
  }

  observeList() {
    this.observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === "childList") {
          this.addListeners()
          this.restoreActiveState()
        }
      }
    })

    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }

  addListeners() {
    this.itemTargets.forEach(item => {
      item.removeEventListener("click", this.setActiveState)
      item.addEventListener("click", this.setActiveState)
    })
  }

  setActiveState(event) {
    const clickedItem = event.currentTarget
    this.activeId = clickedItem.dataset.id

    this.element.dataset.activeId = this.activeId

    this.itemTargets.forEach(item => {
      item.classList.toggle("active", item === clickedItem)
    })
  }

  restoreActiveState() {
    if (!this.activeId)
      return

    this.itemTargets.forEach(item => {
      item.classList.toggle("active", item.dataset.id === this.activeId)
    })
  }
}
